(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-home-design"] && !Shopify.designMode) return;
  try {
    
function initializeMagHomeCarousel(root) {
  const carousel = root.querySelector('[data-mgh-carousel]');
  if (!carousel || carousel.dataset.initialized) return;
  carousel.dataset.initialized = 'true';
  const controller = new AbortController();
  const options = { signal: controller.signal };
  const slides = [...carousel.querySelectorAll('[data-mgh-slide]')];
  const videos = slides.map(slide => slide.querySelector('[data-mgh-video]'));
  const viewport = carousel.querySelector('[data-mgh-viewport]');
  const dots = [...carousel.querySelectorAll('[data-mgh-dot]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pendingPlay = new Set();
  let current = 0;
  let inView = !('IntersectionObserver' in window);
  let observer;
  let timer;
  let remaining = 3000;
  let countdownAt = 0;
  let transitioning = false;
  let queuedTarget = null;
  let disposed = false;
  let animations = [];
  const canRun = () => !disposed && inView && !document.hidden;
  const syncDots = () => dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
  const pauseCountdown = () => {
    if (!timer) return;
    clearTimeout(timer);
    timer = undefined;
    remaining = Math.max(0, remaining - (performance.now() - countdownAt));
  };
  const preloadVideo = index => {
    const video = videos[index];
    if (!video) return;
    video.preload = 'auto';
    if (!video.getAttribute('src')) {
      video.src = video.dataset.videoSrc;
      video.load();
    }
  };
  const startCountdown = () => {
    if (timer || !canRun() || transitioning) return;
    countdownAt = performance.now();
    timer = setTimeout(() => {
      timer = undefined;
      remaining = 0;
      showNext();
    }, Math.max(0, remaining));
  };
  const syncPlayback = () => {
    const running = canRun();
    videos.forEach((video, index) => {
      if (!video) return;
      video.autoplay = running && !transitioning && index === current;
      if (!video.autoplay) video.pause();
    });
    animations.forEach(animation => running ? animation.play() : animation.pause());
    if (!running || transitioning) {
      pauseCountdown();
      return;
    }
    const activeVideo = videos[current];
    if (!activeVideo) {
      preloadVideo((current + 1) % slides.length);
      startCountdown();
      return;
    }
    if (activeVideo.ended) {
      showNext();
      return;
    }
    preloadVideo((current + 1) % slides.length);
    if (remaining > 0) startCountdown();
    if (!activeVideo.paused || pendingPlay.has(activeVideo)) return;
    pendingPlay.add(activeVideo);
    const attempt = activeVideo.play();
    if (!attempt) {
      pendingPlay.delete(activeVideo);
      return;
    }
    attempt.then(() => {
      pendingPlay.delete(activeVideo);
      if (!canRun() || videos[current] !== activeVideo || transitioning) activeVideo.pause();
    }, () => {
      pendingPlay.delete(activeVideo);
      if (disposed || videos[current] !== activeVideo || transitioning) return;
      if (remaining <= 0) remaining = 4000;
      startCountdown();
    });
  };
  const showSlide = index => {
    const target = (index + slides.length) % slides.length;
    if (disposed) return;
    if (transitioning) {
      queuedTarget = target;
      return;
    }
    if (target === current) return;
    pauseCountdown();
    const outgoing = slides[current];
    videos[current]?.pause();
    if (videos[current]) videos[current].autoplay = false;
    current = target;
    syncDots();
    const incoming = slides[current];
    const activeVideo = videos[current];
    remaining = activeVideo ? 0 : 3000;
    preloadVideo(current);
    if (activeVideo) activeVideo.currentTime = 0;
    incoming.hidden = false;
    incoming.setAttribute('aria-hidden', 'false');
    outgoing.setAttribute('aria-hidden', 'true');
    const finish = () => {
      if (disposed) return;
      outgoing.hidden = true;
      animations.forEach(animation => animation.cancel());
      animations = [];
      transitioning = false;
      const nextTarget = queuedTarget;
      queuedTarget = null;
      if (nextTarget !== null && nextTarget !== current) {
        showSlide(nextTarget);
        return;
      }
      syncPlayback();
    };
    if (!canRun() || reducedMotion.matches || typeof incoming.animate !== 'function') {
      finish();
      return;
    }
    transitioning = true;
    const timing = { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
    animations = [
      outgoing.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }], timing),
      incoming.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], timing)
    ];
    Promise.allSettled(animations.map(animation => animation.finished)).then(finish);
  };
  const showNext = () => {
    if (canRun()) showSlide(current + 1);
  };
  dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index), options));
  videos.forEach((video, index) => {
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    video.addEventListener('ended', () => {
      if (index === current) showNext();
    }, options);
    video.addEventListener('playing', () => {
      if (index !== current || !canRun() || transitioning) {
        video.pause();
        return;
      }
      pauseCountdown();
      remaining = 0;
    }, options);
    video.addEventListener('error', () => {
      if (index !== current || disposed) return;
      if (remaining <= 0) remaining = 4000;
      startCountdown();
    }, options);
  });
  carousel.addEventListener('pointerdown', syncPlayback, options);
  document.addEventListener('visibilitychange', syncPlayback, options);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) animations.forEach(animation => animation.finish());
    syncPlayback();
  }, options);
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
      syncPlayback();
    }, { threshold: [0, 0.15] });
    observer.observe(viewport);
  }
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(root)) return;
    disposed = true;
    pauseCountdown();
    videos.forEach(video => {
      if (!video) return;
      video.autoplay = false;
      video.pause();
    });
    animations.forEach(animation => animation.cancel());
    observer?.disconnect();
    controller.abort();
    delete carousel.dataset.initialized;
  }, options);
  slides.forEach((slide, index) => {
    slide.hidden = index !== current;
    slide.setAttribute('aria-hidden', String(index !== current));
  });
  syncDots();
  carousel.querySelector('[data-mgh-dots]').hidden = false;
  preloadVideo(1);
  syncPlayback();
}

function initializeMagHome(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  initializeMagHomeCarousel(root);
  const data = JSON.parse(root.querySelector('[data-home-data]').textContent);
  const brand = root.querySelector('#mgh-phone-brand');
  const model = root.querySelector('#mgh-phone-model');
  const kind = root.querySelector('#mgh-accessory-type');
  const models = {
    Apple: ['iPhone 18 Pro', 'iPhone 18 Pro Max', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone 16 Pro', 'iPhone 15 Pro', 'iPhone 14 Pro', 'iPhone 13'],
    Samsung: ['Galaxy S26', 'Galaxy S26 Plus', 'Galaxy S26 Ultra', 'Galaxy S25 Ultra', 'Galaxy S24 Ultra', 'Galaxy S23 Ultra', 'Galaxy S22 Ultra', 'Galaxy Z Fold6']
  };
  const changeBrand = () => {
    model.replaceChildren(...models[brand.value].map(name => {
      const option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      return option;
    }));
  };
  brand.addEventListener('change', changeBrand);
  root.querySelectorAll('[data-brand]').forEach(button => {
    button.addEventListener('click', () => {
      brand.value = button.dataset.brand;
      changeBrand();
      root.querySelector('#mgh-alege').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      model.focus({ preventScroll: true });
    });
  });
  root.querySelector('[data-build]').addEventListener('click', () => {
    const normalized = model.value.replace('Fold6', 'Fold 6');
    const collection = data.routes[normalized]?.[kind.value];
    const prefix = kind.value === 'all' ? '' : kind.value + ' ';
    const search = '/search?' + new URLSearchParams({ q: prefix + model.value, 'options[prefix]': 'last' });
    window.location.assign(collection || search);
  });
  root.querySelectorAll('[data-mag]').forEach(button => {
    button.addEventListener('click', () => {
      const selected = data.mag[button.dataset.mag];
      root.querySelectorAll('[data-mag]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      const image = root.querySelector('[data-mag-image]');
      image.removeAttribute('srcset');
      image.src = selected.image;
      image.alt = selected.alt;
      root.querySelector('[data-mag-name]').textContent = selected.alt;
      root.querySelector('[data-mag-link]').href = selected.url;
      root.querySelector('[data-mag-photo-link]').href = selected.url;
      root.querySelector('[data-mag-price]').textContent = selected.price;
      const oldPrice = root.querySelector('[data-mag-old-price]');
      oldPrice.textContent = selected.old_price;
      oldPrice.hidden = !(selected.discount > 0);
      const badge = root.querySelector('[data-mag-badge]');
      badge.textContent = '-' + selected.discount + '%';
      badge.hidden = !(selected.discount > 0);
      badge.setAttribute('aria-label', selected.discount_label + ': -' + selected.discount + '%');
    });
  });
  root.querySelectorAll('[data-reveal]').forEach(button => {
    button.addEventListener('click', () => {
      const panel = root.querySelector('[data-reveal-panel="' + button.dataset.reveal + '"]');
      panel.hidden = !panel.hidden;
      button.setAttribute('aria-expanded', String(!panel.hidden));
    });
  });
  const fold = root.querySelector('#mgh-fold-model');
  fold.addEventListener('change', () => {
    const generation = fold.value.match(/\d+/)?.[0] || '6';
    root.querySelector('[data-fold-link]').href = '/collections/huse-z-fold-' + generation;
  });
}
document.querySelectorAll('[data-mag-home]').forEach(initializeMagHome);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-mag-home]').forEach(initializeMagHome);
});


  } catch(e) { console.error(e); }
})();
})();
